<template>
    <div class="page" id="group">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>{{ $route.query.group }}</h2>
                <ul class="links">
                    <li
                        style="transform: translateY(-5px)"
                        v-if="$route.query.group !== 'All Players'"
                    >
                        <button
                            class="openSettings"
                            @click.prevent="deleteOn = !deleteOn"
                            type="button"
                            name="button"
                        >
                            <img class="bin" v-if="!deleteOn" src="@/assets/bin.svg" /><img
                                v-else
                                class="bin"
                                src="@/assets/bin-red.svg"
                            />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'proPlayerMessagesGroups' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <ul id="groupMembers">
                <li v-for="(member, index) in groupMembers" :key="index">
                    {{ member.first_name }} {{ member.last_name }}
                    <button
                        @click.prevent="deleteMember(index)"
                        v-if="deleteOn"
                        class="button red"
                        type="button"
                        name="button"
                    >
                        <img class="minus" src="@/assets/minus.svg" />
                    </button>
                </li>
            </ul>

            <span class="select">
                <select class="button dark center mb10" v-model="player" @change="addMember">
                    <option value="">Add a player</option>
                    <option :value="player" v-for="player in players" :key="player.id">
                        {{ player.first_name }} {{ player.last_name }}
                    </option>
                </select>
                <img class="plus" src="@/assets/arrow-plus-white.svg" />
            </span>
            <has-error class="info error" :form="form" field="player"></has-error>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form, HasError } from "vform";
export default {
    components: { FadeImage, HasError, XIcon },
    created() {
        this.getGroup();
        this.$store.dispatch("getPlayers");
    },
    computed: {
        players() {
            return this.$store.state.players;
        },
    },
    data() {
        return {
            deleteOn: false,
            groupMembers: [],
            player: "",
            form: new Form({
                player: "",
            }),
        };
    },
    methods: {
        addMember() {
            this.form.player = this.player.id;
            this.form
                .put("/group/" + this.$route.params.id)
                .then(() => {
                    this.groupMembers.push(this.player);
                    this.player = "";
                })
                .catch(() => {
                    this.player = "";
                });
        },
        deleteMember(index) {
            this.$confirm("Are you sure you want to remove this member from this group?", () => {
                this.form
                    .delete(
                        "/group/" +
                            this.$route.params.id +
                            "/member/" +
                            this.groupMembers[index].id,
                    )
                    .then(() => {
                        this.groupMembers.splice(index, 1);
                    });
            });
        },
        getGroup() {
            window.axios.get("/group/" + this.$route.params.id).then((response) => {
                this.groupMembers = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#group {
    .select {
        display: block;
        .plus {
            position: absolute;
            top: 20px;
            right: 21px;
        }
    }
    #groupMembers {
        margin-bottom: 30px;

        li {
            border-radius: $radius;
            background: white;
            margin-bottom: 5px;
            position: relative;
            color: $green_0;
            height: 52px;
            padding: 18px 20px;
            button {
                position: absolute;
                right: 0px;
                top: 0px;
                width: 60px;
                height: 100%;
                border-radius: 0px;
                border-top-right-radius: $radius;
                border-bottom-right-radius: $radius;
                width: 64px;
                padding: 0px;
                .minus {
                    margin-left: 7px;
                }
                &:before {
                    content: "";
                    width: 12px;
                    background: blue;
                    height: 100%;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    background: white;
                    border-top-right-radius: $radius;
                    border-bottom-right-radius: $radius;
                }
            }
        }
    }
}
</style>
